import React from 'react';
import { Dropdown as BootstrapDropdown } from 'react-bootstrap';
import {
  StyledDropdown,
  CustomToggle,
  StyledMenu,
  StyledItem,
  StyledDivider,
} from './components/DropdownStyles';
import { renderIconElement } from './utils/dropdownHelpers';

const Dropdown = ({ children, align = 'end', ...props }) => {
  return (
    <StyledDropdown align={align} {...props}>
      {children}
    </StyledDropdown>
  );
};

const DropdownToggle = React.forwardRef(({ children, as, ...props }, ref) => (
  <BootstrapDropdown.Toggle as={as || CustomToggle} ref={ref} {...props}>
    {children}
  </BootstrapDropdown.Toggle>
));

const DropdownMenu = React.forwardRef(({ children, ...props }, ref) => (
  <StyledMenu ref={ref} popperConfig={{ strategy: 'fixed', ...props.popperConfig }} renderOnMount {...props}>
    {children}
  </StyledMenu>
));

const DropdownItem = React.forwardRef(({ children, icon, ...props }, ref) => (
  <StyledItem ref={ref} {...props}>
    {renderIconElement(icon)}
    <span>{children}</span>
  </StyledItem>
));

const DropdownDivider = React.forwardRef((props, ref) => <StyledDivider ref={ref} {...props} />);

Dropdown.Toggle = DropdownToggle;
Dropdown.Menu = DropdownMenu;
Dropdown.Item = DropdownItem;
Dropdown.Divider = DropdownDivider;

export default Dropdown;



// WEBPACK FOOTER //
// ./src/design-system/atoms/Dropdown/Dropdown.jsx